import React, { useState, useEffect } from 'react'
import Header from '../../layouts/Header';
import { Button, Card, Col, Form, ListGroup, Row, Spinner } from 'react-bootstrap';
import Select from "react-select";
import makeAnimated from "react-select/animated";
import DatePicker from "react-datepicker";
import axios from '../../api/axios';
import { toast } from 'react-toastify';
import { format } from 'date-fns';
import { ArrowLeft } from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom';

const customStyles = {
    control: (provided, state) => ({
        ...provided,
        width: "100%",
        borderRadius: '6px',
        minWidth: "200px",
        borderColor: state.isFocused ? "#80bdff" : "#ced4da",
        boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : null,
        "&:hover": {
            borderColor: state.isFocused ? "#80bdff" : "#ced4da",
        },
    }),
    placeholder: (provided) => ({
        ...provided,
        color: "#6c757d"
    }),
};

const CreateCoupon = () => {

    const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
    const [skin, setSkin] = useState(currentSkin);
    const navigate = useNavigate();

    const accessToken = localStorage.getItem("authToken");
    const [addBtnLoading, setAddBtnLoading] = useState(false);
    const animatedComponents = makeAnimated();
    const [addonList, setAddonList] = useState([]);
    const [allAddonList, setAllAddonList] = useState([]);
    const [selectedCheckbox, setSelectedCheckbox] = useState(null);
    const [couponData, setCouponData] = useState({
        isBogoCoupon: false,
        isMrpDiscount: false,
        isCashbackCoupon: false,
        isHidden: "",
        title: "",
        couponCode: "",
        sizeUpgradeAddon: "",
        newSizeUpgradeAddon: "",
        description: "",
        orderType: "ALL",
        discountPercent: "",
        discountAmount: "",
        maxDiscountAmount: "",
        minOrderAmount: "",
        discountPrice: "",
        validityStartDate: "",
        validityEndDate: "",
        dailyUsageLimit: "",
        usageType: "",
        discountPrice: "",
        applicableQuantityType: "",
        dayOfWeek: "",
        startTime: "",
        endTime: "",
        termsAndConditions: [],
        isComboCategoryCoupon: false,
        maxAddonsAllowed: null,
        // Added fields for freebie coupon
        isFreebieCoupon: false,
        freebieProduct: "",
        freebieQuantity: '',
        // 👇 Added fields for addons
        excludedAddonGroups: [],
        excludedAddonValues: [],
    });
    const [sizeCouponProduct, setSizeCouponProduct] = useState({
        applicableProducts: []
    })
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [currentTerm, setCurrentTerm] = useState('');
    const [primaryComboCategories, setPrimaryComboCategories] = useState([])
    const [secondaryComboCategories, setSecondaryComboCategories] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [selectedIncludedOptions, setSelectedIncludedOptions] = useState([]);
    const [selectedCouponOption, setSelectedCouponOption] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [selectedDependentProducts, setSelectedDependentProducts] = useState([]);
    const [selectedDependentCategories, setSelectedDependentCategories] = useState([]);
    const [selectedExcludedProducts, setSelectedExcludedProducts] = useState([]);
    const [selectedLevelOptions, setSelectedLevelOptions] = useState([]);
    const [selectedAddons, setSelectedAddons] = useState([]);
    const [exProductList, setExProductList] = useState([]);
    const [categoriesData, setCategoriesData] = useState([]);
    const [productsList, setProductsList] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState('');
    const [outlets, setOutlets] = useState([]);
    const [levels, setLevels] = useState([]);
    const [productAddonsList, setProductAddonsList] = useState([]);
    const [addonValueList, setAddonValueList] = useState([]);
    const [addonTitleId, setAddonTitleId] = useState([]);
    const [selectedAddonValues, setSelectedAddonValues] = useState([]);
    const [newSizeAddonsList, setNewSizeAddonsList] = useState([]);
    const [newProductsFromAddons, setNewProductsFromAddons] = useState([]);
    const [selectedAddonGroups, setSelectedAddonGroups] = useState([]);
    const [filteredAddonValues, setFilteredAddonValues] = useState([]);
    const [freebieProductsList, setFreebieProductsList] = useState([]); // Added for freebie products

    // Outlet Data Mapping
    const outletData = outlets
        .filter(
            (outlet) =>
                !selectedOptions.some((selected) => selected.value === outlet._id) && // Exclude selected Excluded outlets
                !selectedIncludedOptions.some((selected) => selected.value === outlet._id) // Exclude selected Included outlets
        )
        .map((outlet) => ({
            value: outlet._id,
            label: `${outlet.name} (${outlet.city})`,
        }));

    // const productsInfo = productsList?.map((product) => ({
    //     value: product?._id,
    //     label: `${product?.name}`
    // }))

    const productsInfo = productsList
        .filter(product => product?.isFreebieProduct === false)
        .map(product => ({
            value: product?._id,
            label: product?.name
        }));

    const exProductsInfo = exProductList
        // value: pro?._id,
        // label: `${pro?.name}`
        .filter(product => product?.isFreebieProduct === false)
        .map(product => ({
            value: product?._id,
            label: product?.name
        }));


    const addonsInfo = productAddonsList?.map((add) => ({
        value: add?._id,
        label: <span>
            {add?.addonTitle} <span className=''>{" -> "}</span> <span style={{ color: "grey" }}> {add?.product?.name}</span>
        </span>
    }))

    const addonsProducts = newProductsFromAddons?.map((item) => ({
        value: item?._id,
        label: item?.name
    }))

    const exAddonsProducts = newProductsFromAddons?.map((item) => ({
        value: item?._id,
        label: item?.name
    }))

    // Freebie Products List - only products with isFreebieProduct = true
    const freebieProductsOptions = freebieProductsList
        .filter(product => product.isFreebieProduct === true)
        .map((product) => ({
            value: product?._id,
            label: `${product?.name}`
        }))

    // Map the originalAddonValues
    const addonsValueInfo = addonValueList?.flatMap((addon) =>
        addon?.originalAddonValues?.map((original) => ({
            adTitleId: addon._id,
            value: original?._id, // Assuming originalAddonValues have an _id property
            label: (
                <span>
                    {original?.value || "No Name"}{" "}
                    <span className="">{" -> "}</span> <span style={{ color: "grey" }}> {addon?.addonTitle}</span> <span className="">{" >> "}</span> <span style={{ color: "grey" }}> {addon?.product?.name}</span>
                </span>
            ),
        }))
    );

    const levelsData = levels.map((level) => ({
        value: level._id,
        label: `${level.sequenceNo}. ${level.title}`
    }))

    const categoriesList = categoriesData.map((category) => ({
        value: category._id,
        label: `${category.name}`
    }));

    // Fetches the products list from the server and updates state.
    const getProductsList = async (catId) => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("product", { headers });

            if (response?.data?.status === true) {
                setProductsList(response?.data?.data?.products);

                // Also set freebie products list
                const allProducts = response?.data?.data?.products;
                setFreebieProductsList(allProducts); // Store all products for freebie filtering

                if (catId) {
                    let excludedProducts = response?.data?.data?.products?.filter((fi) =>
                        catId?.some((category) => category.value === fi?.category?._id)
                    );
                    // setExProductList(catId ? excludedProducts : allProducts);
                    setExProductList(allProducts);
            
                } else {
                    setExProductList(allProducts);
                }
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    // Fetches the outlet list from the server and updates state.
    const getOutlets = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("outlet", { headers });

            if (response?.data?.status === true) {
                setOutlets(response?.data?.data?.outlets);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const getLevels = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("level", { headers });
            if (response?.data?.status === true) {
                const levels = response?.data?.data?.levels;
                setLevels(levels)
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const getAddonProductsList = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("product-addon?limit=1000&page=1", { headers });
            if (response?.data?.status === true) {
                const addOns = response?.data?.data?.productAddons
                // const sizeAddons = addOns.filter((item) => item?.addonTitle === "Size");
                const productsWithSizeAddon = addOns.filter((item) =>
                    item.addons.some((addon) => addon.addonTitle.toLowerCase() === 'size')
                );
                setAddonList(productsWithSizeAddon)
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const getCategoryProductAddons = async (categ, prod, addIds) => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }

            let categories = categ?.map((opt) => opt?.value);
            let products = prod?.map((opt) => opt?.value);
            // Construct the payload with arrays
            const payload = {
                applicableCategories: categories,
                applicableProducts: products,
            };

            if (payload?.applicableCategories?.length === 0) {
                delete payload?.applicableCategories
            }

            if (payload?.applicableProducts?.length === 0) {
                delete payload?.applicableProducts
            }

            console.log("Payload to send:", payload);

            const response = await axios.post("/coupons/get-dependant-product-category-addons", payload, { headers });
            setProductAddonsList(response?.data?.data?.addons);
            let filteredAddonValues = response?.data?.data?.addons?.filter((val) =>
                addIds?.includes(val?._id) // Check if val._id exists in addIds
            );
            setAddonValueList(filteredAddonValues);
        } catch (error) {
            console.log("Error :", error);
        }
    };

    // Fetches the category list from the server and updates state. 
    const getCategoryList = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("masters/category/get", { headers });

            if (response?.data?.status === true) {
                setCategoriesData(response?.data?.data?.categories);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    // Updates coupon data state with values from input fields.
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const updatedValue = name === "couponCode" ? value.toUpperCase() : value;

        setSizeCouponProduct((prev) => ({
            ...prev,
            [name]: name === "applicableProducts" ? [value] : value
        }));

        if (name === "applicableProducts") {
            setSelectedProduct(value);
        }

        setCouponData((prev) => ({ ...prev, [name]: updatedValue }));
    };

    // Sets the start date for the coupon, or logs an error if date is invalid.
    const handleFromDateChange = (date) => {
        if (date) {
            setFromDate(date);
        } else {
            console.error("Received null or undefined date");
        }
    };

    // Sets the end date for the coupon, or logs an error if date is invalid.
    const handleToDateChange = (date) => {
        if (date) {
            setToDate(date);
        } else {
            console.error("Received null or undefined date");
        }
    };

    const addTerm = () => {
        if (!currentTerm.trim()) return;

        setCouponData((prevData) => ({
            ...prevData,
            termsAndConditions: [...(prevData?.termsAndConditions || []), currentTerm],
        }));

        setCurrentTerm(''); // Clear input after adding
    };

    const removeTerm = (index) => {
        setCouponData((prevData) => ({
            ...prevData,
            termsAndConditions: (prevData?.termsAndConditions || []).filter(
                (_, i) => i !== index
            ),
        }));
    };

    const filteredAddons = selectedProduct
        ? addonList.filter(rm => rm.product._id === selectedProduct)
        : [];
    const updatedFilteredAddons = filteredAddons?.map((item) => item.addons?.map((mm) => mm));

    //Sets Excluded Outlets
    const handleSelectExOutletChange = (out) => {
        setSelectedOptions(out);
    };

    //Sets Included Outlets
    const handleSelectIncOutletChange = (out) => {
        setSelectedIncludedOptions(out);
    };

    // Sets Primary Combo Categories
    const handleSelectPrimaryComboCategories = (cat) => {
        setPrimaryComboCategories(cat)
    };

    // Sets Secondary Combo Categories
    const handleSelectSecondaryComboCategories = (cat) => {
        setSecondaryComboCategories(cat)
    };

    //Sets Applicable Categories
    const handleSelectCategoryChange = (cats) => {
        setSelectedCategories(cats);
        getCategoryProductAddons(cats, selectedProducts);
        getProductsList(cats);
    };

    //Sets Applicable Products
    const handleSelectProductChange = (prods) => {
        setSelectedProducts(prods);
        getCategoryProductAddons(selectedCategories, prods);
    };

    //Sets Dependent Products
    const handleSelectDeProductsChange = (depro) => {
        setSelectedDependentProducts(depro);
    };

    //Sets Dependent Products
    const handleSelectDeCategoriesChange = (decat) => {
        setSelectedDependentCategories(decat);
    };

    //Sets Excluded Products
    const handleSelectExProductsChange = (expro) => {
        setSelectedExcludedProducts(expro);
    };

    //Sets Addons Title
    const handleSelectAddonsChange = (add) => {
        console.log("Addons of Handle CHange :", add);
        // setSelectedAddons(add);

        // Extract all addon values into the `addonTitleId` array
        const selectedIds = add.map((item) => item.value);
        getCategoryProductAddons(selectedCategories, selectedProducts, selectedIds);
        // Update the state with the selected IDs and addons
        setAddonTitleId(selectedIds);

        // Map through the array of selected addon values
        let combinedAddonTitleData = add.map((addon) => ({
            name: addon?.label?.props?.children[0], // Extract the label
            id: addon?.value                       // Extract the value
        }));
        setSelectedAddons(combinedAddonTitleData)

        console.log("Combined Addon Title Data:", combinedAddonTitleData);
    };

    //Sets Addon Values
    const handleSelectAddonValueChange = (val) => {
        // Map through the array of selected addon values
        let combinedData = val.map((addon) => ({
            name: addon?.label?.props?.children[0], // Extract the label
            adValueId: addon?.value,                       // Extract the value
            adTitleId: addon?.adTitleId
        }));
        setSelectedAddonValues(combinedData)
    };

    //Sets All Addon Titles
    const handleSelectAllAddonChange = (fieldName, selectedOptions) => {
        console.log("Field name:", fieldName, "selectedOptions:", selectedOptions);

        let selectedItems = [];
        let addonValuesOptions = [];

        if (fieldName === 'excludedAddonGroups') {
            // Update selected addon groups
            setSelectedAddonGroups(selectedOptions || []);

            // ✅ If no addons selected, clear values and reset form data
            if (!selectedOptions || selectedOptions.length === 0) {
                setFilteredAddonValues([]);
                setCouponData(prev => ({
                    ...prev,
                    [fieldName]: [],
                    excludedAddonValues: [] // clear dependent addon values
                }));
                return;
            }

            // ✅ Generate addon value options only for selected addons
            addonValuesOptions = selectedOptions.flatMap(option => {
                const addon = allAddonList?.find(a => a?._id === option?.value);
                if (!addon) return [];

                return addon?.addonValues?.map(val => ({
                    value: {
                        addonId: addon._id,
                        addValueId: val._id,
                        addonTitle: addon.title,
                        addonValueTitle: val.value
                    },
                    label: `${addon.title} - ${val.value}`
                })) || [];
            });

            // ✅ Store the selected addon groups (for couponData)
            selectedItems = allAddonList.filter(addon =>
                selectedOptions.some(option => option.value === addon._id)
            );

            // ✅ Update filtered values list
            setFilteredAddonValues(addonValuesOptions);

            // ✅ Remove excludedAddonValues that no longer belong to selected groups
            setCouponData(prev => {
                const filteredExcludedValues = (prev.excludedAddonValues || []).filter(val =>
                    selectedOptions.some(opt => opt.value === val.addonId)
                );

                return {
                    ...prev,
                    [fieldName]: selectedItems,
                    excludedAddonValues: filteredExcludedValues
                };
            });

            return; // end here to avoid duplicate setCouponData below
        }

        // Default update for other fields (if needed)
        setCouponData(prev => ({
            ...prev,
            [fieldName]: selectedItems
        }));
    };

    //Sets Levels
    const handleSelectLevelChange = (selected) => {
        setSelectedLevelOptions(selected);
    };

    // Toggles the selected checkbox button, deselecting it if clicked again.
    const handleCheckboxChange = (id) => {
        setSelectedCheckbox((prev) => (prev === id ? null : id));
        setCouponData((prevData) => ({
            ...prevData,
            isBogoCoupon: id === 'isBogoCoupon',
            isFreebieCoupon: id === 'isFreebieCoupon', // Added this
            isComboCategoryCoupon: id === 'isComboCoupon' ? prevData.isComboCategoryCoupon : false,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setAddBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }

            let selectedApplicableCategory = selectedCategories?.map((cat) => cat?.value);
            let selectedApplicableProduct = selectedProducts?.map((prod) => prod?.value);
            let selectedExcludedOutlets = selectedOptions?.map((options) => options?.value);
            let selectedIncludedOutlets = selectedIncludedOptions?.map((options) => options?.value);
            let selectedDepProducts = selectedDependentProducts?.map((dep) => dep?.value);
            let selectedDepCategories = selectedDependentCategories?.map((dec) => dec?.value);
            let selectedExcProducts = selectedExcludedProducts?.map((prods) => prods?.value);
            let selectedAddonTitle = selectedAddons?.map((add) => add?.value);
            let selectedLevels = selectedLevelOptions?.map((lev) => lev?.value);
            let selectedPrimaryComboCats = primaryComboCategories?.map((cat) => cat.value)
            let selectedSecondaryComboCats = secondaryComboCategories?.map((cat) => cat.value)
            const selectedProductsData = sizeCouponProduct?.applicableProducts.map((c) => c);

            // Construct dependantAddonInfo
            let dependantAddonInfo = selectedAddonValues.map((addonValue) => {
                const matchedAddonTitle = selectedAddons.find(
                    (titleId) => titleId.id === addonValue.adTitleId // Match the addonValue with its title ID
                );
                return {
                    _id: matchedAddonTitle?.id, // Addon Title ID
                    addonValue: addonValue?.name, // Addon Value Name
                    addonValueId: addonValue?.adValueId  // Addon Value ID
                };
            });

            // Construct excludedAddons payload
            let excludedAddonsPayload = (couponData?.excludedAddonValues || []).map((val) => {
                const addon = allAddonList.find(a => a._id === val.addonId);
                const addonValue = addon?.addonValues?.find(v => v._id === val.addValueId);

                return {
                    addonId: val.addonId,
                    addonValueId: val.addValueId,
                    addonTitle: addon?.title || "",
                    addonValueTitle: addonValue?.value || ""
                };
            });

            let updatedCouponData = {
                ...couponData,
                applicableCategories: selectedApplicableCategory,
                applicableProducts: selectedApplicableProduct,
                excludedOutlets: selectedExcludedOutlets,
                includedOutlets: selectedIncludedOutlets,
                dependantProducts: selectedDepProducts,
                dependantCategories: selectedDepCategories,
                excludedProductList: selectedExcProducts,
                dependantAddonInfo: dependantAddonInfo,
                applicableLevels: selectedLevels,
                primaryComboCategories: selectedPrimaryComboCats,
                secondaryComboCategories: selectedSecondaryComboCats,
                excludedAddons: excludedAddonsPayload // 👈 added here
            }

            if (selectedProductsData?.length > 0) {
                updatedCouponData = {
                    ...updatedCouponData,
                    applicableProducts: selectedProductsData
                }
            }

            // Set isFreebieCoupon based on checkbox selection
            updatedCouponData.isFreebieCoupon = selectedCheckbox === 'isFreebieCoupon';

            if (updatedCouponData?.freebieQuantity === "") {
                delete updatedCouponData.freebieQuantity;
            }

            if (updatedCouponData?.freebieProduct === "") {
                delete updatedCouponData.freebieProduct;
            }

            if (updatedCouponData?.primaryComboCategories?.length === 0) {
                delete updatedCouponData?.primaryComboCategories
            }

            if (updatedCouponData?.excludedAddons?.length === 0) {
                delete updatedCouponData.excludedAddons;
            }

            if (updatedCouponData?.secondaryComboCategories?.length === 0) {
                delete updatedCouponData?.secondaryComboCategories
            }

            if (updatedCouponData?.applicableCategories?.length === 0) {
                delete updatedCouponData?.applicableCategories
            }

            // For freebie coupon, remove discount fields
            if (updatedCouponData?.isFreebieCoupon) {
                delete updatedCouponData.discountPercent;
                delete updatedCouponData.discountAmount;
                delete updatedCouponData.maxDiscountAmount;
                delete updatedCouponData.discountPrice;
                delete updatedCouponData.isMrpDiscount;
                delete updatedCouponData.isCashbackCoupon;
                delete updatedCouponData.applicableQuantityType;
            }

            if (updatedCouponData?.applicableProducts?.length === 0) {
                delete updatedCouponData?.applicableProducts
            }

            if (!updatedCouponData?.newSizeUpgradeAddon) {
                delete updatedCouponData.newSizeUpgradeAddon;
            }

            if (updatedCouponData?.excludedOutlets?.length === 0) {
                delete updatedCouponData?.excludedOutlets
            }

            if (updatedCouponData?.includedOutlets?.length === 0) {
                delete updatedCouponData?.includedOutlets
            }

            if (updatedCouponData?.dependantAddonInfo?.length === 0) {
                delete updatedCouponData?.dependantAddonInfo
            }

            if (updatedCouponData?.dependantProducts?.length === 0) {
                delete updatedCouponData?.dependantProducts
            }

            if (updatedCouponData?.dependantCategories?.length === 0) {
                delete updatedCouponData?.dependantCategories
            }

            if (updatedCouponData?.excludedProductList?.length === 0) {
                delete updatedCouponData?.excludedProductList
            }

            if (updatedCouponData?.applicableLevels?.length === 0) {
                delete updatedCouponData?.applicableLevels
            }

            if (updatedCouponData?.startTime === "") {
                delete updatedCouponData.startTime
            }

            if (updatedCouponData?.endTime === "") {
                delete updatedCouponData.endTime
            }

            if (updatedCouponData?.usageType === "") {
                delete updatedCouponData.usageType
            }

            if (updatedCouponData?.dailyUsageLimit === "") {
                delete updatedCouponData.dailyUsageLimit
            }

            if (updatedCouponData?.dayOfWeek === "" || updatedCouponData?.dayOfWeek === "all") {
                delete updatedCouponData.dayOfWeek
            }

            if (updatedCouponData?.applicableCategories?.length === 0) {
                delete updatedCouponData?.applicableCategories
            }

            if (updatedCouponData?.isHidden === "") {
                delete updatedCouponData.isHidden
            }

            if (updatedCouponData?.discountAmount === "") {
                delete updatedCouponData?.discountAmount
            }

            if (updatedCouponData?.discountPercent === "") {
                delete updatedCouponData?.discountPercent
            }

            if (updatedCouponData?.discountPrice === "") {
                delete updatedCouponData?.discountPrice
            }

            if (updatedCouponData?.isMrpDiscount === "") {
                delete updatedCouponData?.isMrpDiscount
            }

            if (updatedCouponData?.maxDiscountAmount === "") {
                delete updatedCouponData?.maxDiscountAmount
            }

            if (updatedCouponData?.minOrderAmount === "") {
                delete updatedCouponData?.minOrderAmount
            }

            if (updatedCouponData?.applicableQuantityType === "") {
                delete updatedCouponData?.applicableQuantityType
            }

            if (updatedCouponData?.termsAndConditions?.length === 0) {
                delete updatedCouponData?.termsAndConditions
            }

            if (updatedCouponData?.sizeUpgradeAddon === "") {
                delete updatedCouponData.sizeUpgradeAddon
            }

            if (updatedCouponData?.validityStartDate === "" || updatedCouponData?.validityStartDate === null) {
                delete updatedCouponData.validityStartDate
            }

            if (updatedCouponData?.validityEndDate === "" || updatedCouponData?.validityEndDate === null) {
                delete updatedCouponData.validityEndDate
            }

            // For freebie coupon, validate required fields
            if (updatedCouponData?.isFreebieCoupon && !updatedCouponData.freebieProduct) {
                toast.error("Please select a freebie product", {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                setAddBtnLoading(false);
                return;
            }

            console.log("Final coupon data to send:", updatedCouponData);

            const response = await axios.post("coupons", updatedCouponData, { headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                navigate('/coupons/coupons-list');
                e.target.reset();
                setSelectedCheckbox(null);
                setSelectedOptions([]);
                setSelectedIncludedOptions([]);
                setSelectedDependentCategories([]);
                setSelectedDependentProducts([]);
                setSelectedCategories([]);
                setSelectedProducts([]);
                setSelectedLevelOptions([]);
                setSelectedExcludedProducts([]);
                setSelectedAddons([]);
                setSelectedCouponOption("");
                setPrimaryComboCategories([]);
                setSecondaryComboCategories([]);
                setSelectedAddonGroups([]);
                setCouponData({
                    title: "",
                    isHidden: "",
                    couponCode: "",
                    description: "",
                    usageType: "",
                    discountPercent: "",
                    discountAmount: "",
                    maxDiscountAmount: "",
                    minOrderAmount: "",
                    validityStartDate: "",
                    validityEndDate: "",
                    applicableLevels: "",
                    dayOfWeek: "",
                    endTime: "",
                    startTime: "",
                    dailyUsageLimit: "",
                    excludedAddonValues: [],
                    orderType: "ALL",
                    newSizeUpgradeAddon: '',
                    maxAddonsAllowed: null,
                    isMrpDiscount: false,
                    isCashbackCoupon: false,
                    isFreebieCoupon: false,
                    freebieProduct: "",
                    freebieQuantity: ""
                });
                setFromDate(null);
                setToDate(null);
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = "";
                if (error.response?.status === 406) {
                    errorMessage =
                        error?.response?.data?.error?.message ||
                        error?.response?.data?.error;
                } else if (error.response?.status === 412) {
                    errorMessage =
                        error?.response?.data?.data?.message ||
                        error?.response?.data?.data?.title;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error;
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setAddBtnLoading(false);
        }
    }

    // New Size Addons Api 
    const getNewSizeAddons = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }
            const response = await axios.get('/product/getSizeUpgradeAddonsWithProducts', { headers });
            console.log("Response of new size addons :", response?.data?.data);
            setNewSizeAddonsList(response?.data?.data?.addons);
            let newproducts = response?.data?.data?.addons?.flatMap((add) => add?.products || []);
            setNewProductsFromAddons(newproducts);
        } catch (error) {
            console.log("Error :", error);
        }
    }

    const getAddonList = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("addons?page=1&limit=100", { headers });
            console.log("Response of all addons :", response?.data?.data);

            if (response?.data?.status === true) {
                console.log("Response of all addons :", response?.data?.data?.addons);
                setAllAddonList(response?.data?.data?.addons);
            }
        } catch (error) {
            toast.error(error?.response?.data?.error || "Failed to fetch addons", {
                position: "top-right",
                autoClose: 3000,
                theme: "light",
            });
        }
    };

    useEffect(() => {
        const formattedStartDate = fromDate ? format(fromDate, "yyyy-MM-dd") : "";
        const formattedEndDate = toDate ? format(toDate, "yyyy-MM-dd") : "";

        setCouponData((prev) => ({
            ...prev,
            validityStartDate: formattedStartDate,
            validityEndDate: formattedEndDate,
        }));
    }, [fromDate, toDate]);

    useEffect(() => {
        getCategoryList();
        getProductsList();
        getOutlets();
        getNewSizeAddons();
        getLevels();
        getAddonProductsList();
        getAddonList();
    }, []);

    // Clear selected values when the field is disabled For Applicable Categories
    useEffect(() => {
        if (
            selectedCheckbox === "isBogoCoupon" ||
            selectedCheckbox === "isSizeUpgradeCoupon" ||
            selectedCheckbox === "isSpecialProductCoupon" ||
            selectedCheckbox === "isUniversalCoupon" ||
            selectedCheckbox === "isCartCoupon" ||
            selectedCheckbox === "isFreebieCoupon" // Added this
        ) {
            setSelectedCategories([]); // Clear categories when disabled 
        }
    }, [selectedCheckbox]);

    // <--------------- Applicable Products ------------->
    useEffect(() => {
        if (
            selectedCheckbox === "isBogoCoupon" ||
            selectedCheckbox === "isSpecialCategoryCoupon" ||
            selectedCheckbox === "isCategoryCoupon" ||
            selectedCheckbox === "isUniversalCoupon" ||
            selectedCheckbox === "isCartCoupon" ||
            selectedCheckbox === "isFreebieCoupon" // Added this
        ) {
            setSelectedProducts([]); // Clear products when disabled
        }
    }, [selectedCheckbox]);

    // Effects to reset fields when disabled
    useEffect(() => {
        if (
            selectedCheckbox === "isBogoCoupon" ||
            selectedCheckbox === "isSizeUpgradeCoupon" ||
            selectedCheckbox === "isCartCoupon" ||
            selectedCheckbox === "isUniversalCoupon" ||
            selectedCheckbox === "isFreebieCoupon" // Added this
        ) {
            setSelectedAddons([]); // Clear addons
            setSelectedAddonValues([]); // Clear addon values
            setSelectedExcludedProducts([]); // Clear excluded products
        }
    }, [selectedCheckbox]);

    useEffect(() => {
        if (
            selectedCheckbox === "isBogoCoupon" ||
            selectedCheckbox === "isSizeUpgradeCoupon" ||
            selectedCheckbox === "isCartCoupon" ||
            selectedCheckbox === "isUniversalCoupon" ||
            selectedCheckbox === "isFreebieCoupon" // Added this
        ) {
            setSelectedDependentCategories([]); // Clear dependent categories
            setSelectedDependentProducts([]); // Clear dependent products
        }
    }, [selectedCheckbox]);

    // Reset specific fields when they are disabled based on selectedCheckbox
    useEffect(() => {
        if (selectedCheckbox === "isUniversalCoupon" ||
            selectedCheckbox === "isBogoCoupon" ||
            selectedCheckbox === "isCartCoupon" ||
            selectedCheckbox === "isProductCoupon" ||
            selectedCheckbox === "isCategoryCoupon" ||
            selectedCheckbox === "isSpecialCategoryCoupon" ||
            selectedCheckbox === "isSpecialProductCoupon" ||
            selectedCheckbox === "isFreebieCoupon") { // Added this
            setCouponData((prev) => ({
                ...prev,
                sizeUpgradeAddon: "",
                discountPercent: "",
                discountAmount: "",
                maxDiscountAmount: "",
                discountPrice: "",
                applicableQuantityType: "",
            }));
        }
    }, [selectedCheckbox]);

    // Effect to clear freebie product when freebie coupon is not selected
    useEffect(() => {
        if (selectedCheckbox !== 'isFreebieCoupon') {
            setCouponData(prev => ({
                ...prev,
                freebieProduct: "",
                freebieQuantity: ""
            }));
        }
    }, [selectedCheckbox]);

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className="main main-app p-3 p-lg-4">
                <div className="container shadow-sm" style={{ backgroundColor: "white" }}>
                    <Row className='pt-1'>
                        <Col>
                            <div className="card-header bg-white border-0 py-2 d-flex justify-content-between align-items-center">
                                <div>
                                    <h4 className="mb-0 fw-bold d-inline-block">
                                        <i className="bi bi-tag-fill me-2"></i>CREATE COUPON
                                    </h4>
                                </div>
                                <div>
                                    <Button
                                        variant="outline-secondary"
                                        size="sm"
                                        onClick={() => navigate('/coupons/coupons-list')} // Or specify your desired route
                                        className="me-3 w-100 d-flex align-items-center fw-semibold"
                                        style={{ height: '34px' }}

                                    >
                                        <ArrowLeft className="me-2" /> Back To Coupon Listing
                                    </Button>
                                </div>
                            </div>
                        </Col>
                        <hr />
                    </Row>

                    <Row>
                        <Col>
                            <Form onSubmit={handleSubmit}>
                                <Card.Body>
                                    <Row className="mb-3">
                                        <Col xs={12} md={12} lg={12} className="d-flex justify-content-center mb-3">
                                            {selectedCheckbox ? (
                                                <span
                                                    className="fw-semibold text-white"
                                                    style={{
                                                        fontSize: '15px',
                                                        backgroundColor: '#3AB857',
                                                        padding: '5px 15px',
                                                        borderRadius: '18px',
                                                    }}
                                                >
                                                    {
                                                        [
                                                            { id: 'isBogoCoupon', description: 'Description - BOGO coupon allows you to buy one and get another one free.' },
                                                            { id: 'isUniversalCoupon', description: 'Description - Universal coupon can be applied to any item in the store.' },
                                                            { id: 'isCartCoupon', description: 'Description - Cart coupon gives a discount on the entire cart.' },
                                                            { id: 'isSizeUpgradeCoupon', description: 'Description - Size upgrade coupon lets you upgrade the product size for free or a discount.' },
                                                            { id: 'isProductCoupon', description: 'Description - Product coupon provides a discount on a specific product.' },
                                                            { id: 'isCategoryCoupon', description: 'Description - Category coupon gives a discount on all items in a particular category.' },
                                                            { id: 'isSpecialCategoryCoupon', description: 'Description - Special category coupon applies to selected special categories only.' },
                                                            { id: 'isSpecialProductCoupon', description: 'Description - Special product coupon offers discounts on special, featured products.' },
                                                            { id: 'isComboCoupon', description: 'Description - Combo Coupon type allow you to create a coupon in which two products from two category group can be sold at specific price or specific discount can be applied.' },
                                                            { id: 'isFreebieCoupon', description: 'Description - Freebie coupon offer product for no cost or for 0 Rs' },
                                                        ].find((item) => item.id === selectedCheckbox)?.description
                                                    }
                                                </span>
                                            ) : (
                                                <span
                                                    className="fw-semibold text-muted"
                                                    style={{
                                                        fontSize: '15px',
                                                        backgroundColor: '#E0FFD9',
                                                        padding: '5px 15px',
                                                        borderRadius: '18px',
                                                    }}
                                                >
                                                    Please Select a Coupon Type From Above
                                                </span>
                                            )}
                                        </Col>
                                        {[
                                            { id: 'isBogoCoupon', label: 'BOGO COUPON', description: 'BOGO coupon allows you to buy one and get another one free.' },
                                            { id: 'isUniversalCoupon', label: 'UNIVERSAL COUPON', description: 'Universal coupon can be applied to any item in the store.' },
                                            { id: 'isCartCoupon', label: 'CART COUPON', description: 'Cart coupon gives a discount on the entire cart.' },
                                            { id: 'isSizeUpgradeCoupon', label: 'SIZE UPGRADE COUPON', description: 'Size upgrade coupon lets you upgrade the product size for free or a discount.' },
                                            { id: 'isProductCoupon', label: 'PRODUCT COUPON', description: 'Product coupon provides a discount on a specific product.' },
                                            { id: 'isCategoryCoupon', label: 'CATEGORY COUPON', description: 'Category coupon gives a discount on all items in a particular category.' },
                                            { id: 'isSpecialCategoryCoupon', label: 'SPECIAL CATEGORY COUPON', description: 'Special category coupon applies to selected special categories only.' },
                                            { id: 'isSpecialProductCoupon', label: 'SPECIAL PRODUCT COUPON', description: 'Special product coupon offers discounts on special, featured products.' },
                                            { id: 'isComboCoupon', label: 'COMBO COUPON', description: 'Special product coupon offers discounts on special, featured products.' },
                                            { id: 'isFreebieCoupon', label: 'FREEBIE COUPON', description: 'Freebie coupon offer product for no cost or for 0 Rs' },
                                        ].map((button) => (
                                            <Col md={3} className="mb-3" key={button.id}>
                                                <Button
                                                    variant={selectedCheckbox === button.id ? 'primary' : 'outline-secondary'}
                                                    onClick={() => handleCheckboxChange(button.id)}
                                                    className={`toggle-button ${selectedCheckbox === button.id ? 'selected' : ''} w-100`}
                                                >
                                                    {button.label}
                                                </Button>
                                            </Col>
                                        ))}
                                    </Row>

                                    <Row>
                                        {selectedCheckbox === 'isComboCoupon' && (
                                            <Col xs={4} md={4} lg={4} className="d-flex mb-3">
                                                <Form.Check
                                                    label="Is Combo Category Coupon ?"
                                                    id="comboCategoryCheckbox"
                                                    checked={couponData.isComboCategoryCoupon}
                                                    onChange={(e) => setCouponData((prev) => ({ ...prev, isComboCategoryCoupon: e.target.checked }))}
                                                />
                                            </Col>
                                        )}
                                    </Row>

                                    <Row>
                                        <Col md={3}>
                                            <div>
                                                <Form.Label className="fw-semibold">
                                                    Title <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    placeholder="Title"
                                                    name="title"
                                                    value={couponData.title || ""}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                        </Col>

                                        <Col md={3}>
                                            <div>
                                                <Form.Label className="fw-semibold">
                                                    Coupon Code <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    placeholder="Coupon Code"
                                                    name="couponCode"
                                                    value={couponData.couponCode || ""}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                        </Col>

                                        <Col className="mb-3" md={2}>
                                            <div>
                                                <Form.Label className="fw-semibold">
                                                    Validity Start Date
                                                </Form.Label>
                                                <DatePicker
                                                    selected={fromDate}
                                                    onChange={handleFromDateChange}
                                                    placeholderText="Start Date"
                                                    className="form-control"
                                                />
                                            </div>
                                        </Col>

                                        <Col md={2}>
                                            <div>
                                                <Form.Label className="fw-semibold">
                                                    Validity End Date
                                                </Form.Label>
                                                <DatePicker
                                                    selected={toDate}
                                                    onChange={handleToDateChange}
                                                    placeholderText="End Date"
                                                    className="form-control"
                                                />
                                            </div>
                                        </Col>

                                        <Col md={2}>
                                            <Form.Group>
                                                <Form.Label className='fw-semibold'>
                                                    Order Type <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Select
                                                    name="orderType"
                                                    value={couponData.orderType || ""}
                                                    onChange={handleInputChange}
                                                >
                                                    <option value="ALL">ALL</option>
                                                    <option value="DELIVERY">DELIVERY</option>
                                                    <option value="PICKUP">PICK-UP</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>

                                        <Col md={3}>
                                            <div className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Select Day of a week
                                                </Form.Label>
                                                <Form.Select
                                                    onChange={handleInputChange}
                                                    name="dayOfWeek"
                                                    className="mb-3"
                                                    aria-label="Small select example"
                                                    value={couponData?.dayOfWeek}
                                                >
                                                    <option value="">Select Day</option>
                                                    <option value="0">SUNDAY</option>
                                                    <option value="1">MONDAY</option>
                                                    <option value="2">TUESDAY</option>
                                                    <option value="3">WEDNESDAY</option>
                                                    <option value="4">THURSDAY</option>
                                                    <option value="5">FRIDAY</option>
                                                    <option value="6">SATURDAY</option>
                                                    <option value="all">ANY DAY OF THE WEEK</option>
                                                </Form.Select>
                                            </div>
                                        </Col>

                                        <Col md={3}>
                                            <div>
                                                <Form.Label className="fw-semibold">
                                                    Usage Type <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Select
                                                    name="usageType"
                                                    value={couponData.usageType}
                                                    onChange={handleInputChange}
                                                >
                                                    <option value="">Select Usage</option>
                                                    <option value="ONE-TIME">ONE-TIME</option>
                                                    <option value="MULTIPLE">MULTIPLE</option>
                                                </Form.Select>
                                            </div>
                                        </Col>

                                        <Col md={2}>
                                            <div>
                                                <Form.Label className="fw-semibold">
                                                    Daily Usage Limit
                                                </Form.Label>
                                                <Form.Control
                                                    name="dailyUsageLimit"
                                                    value={couponData.dailyUsageLimit}
                                                    onChange={handleInputChange}
                                                    type="number"
                                                    placeholder="Set Daily Usage Limit"
                                                    className="form-control"
                                                />
                                            </div>
                                        </Col>

                                        <Col md="2" lg="2">
                                            <div className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Start Time
                                                </Form.Label>
                                                <Form.Control
                                                    type="time"
                                                    placeholder="Opening Time"
                                                    className="form-control"
                                                    name="startTime"
                                                    value={couponData.startTime}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                        </Col>

                                        <Col md="2" lg="2">
                                            <div className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    End Time
                                                </Form.Label>
                                                <Form.Control
                                                    type="time"
                                                    placeholder="Closing Time"
                                                    className="form-control"
                                                    name="endTime"
                                                    min="0"
                                                    value={couponData.endTime}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                        </Col>

                                        <Col md="6" className="mb-3">
                                            <Form.Label className="fw-semibold">
                                                Select Included Outlets
                                            </Form.Label>
                                            <Select
                                                isMulti
                                                components={animatedComponents}
                                                value={selectedIncludedOptions}
                                                onChange={handleSelectIncOutletChange}
                                                options={outletData}
                                                styles={customStyles}
                                                placeholder="Select Included Outlets"
                                                isDisabled={!!selectedOptions?.length}
                                                closeMenuOnSelect={false}
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 0,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: "#e9ecef",
                                                        primary: "#007bff",
                                                    },
                                                })}
                                            />
                                        </Col>

                                        <Col md="6" className="mb-3">
                                            <Form.Label className="fw-semibold">
                                                Select Excluded Outlets
                                            </Form.Label>
                                            <Select
                                                isMulti
                                                components={animatedComponents}
                                                value={selectedOptions}
                                                onChange={handleSelectExOutletChange}
                                                options={outletData}
                                                styles={customStyles}
                                                placeholder="Select Excluded Outlets"
                                                isDisabled={!!selectedIncludedOptions?.length}
                                                closeMenuOnSelect={false}
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 0,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: "#e9ecef",
                                                        primary: "#007bff",
                                                    },
                                                })}
                                            />
                                        </Col>

                                        {/* Freebie Product Selection (Only for Freebie Coupon) */}
                                        {selectedCheckbox === 'isFreebieCoupon' && (
                                            <>
                                                <Col md={4}>
                                                    <Form.Group>
                                                        <Form.Label className="fw-semibold">
                                                            Freebie Product <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <Select
                                                            name="freebieProduct"
                                                            options={freebieProductsOptions}
                                                            value={freebieProductsOptions.find(option => option.value === couponData.freebieProduct) || null}
                                                            onChange={(selectedOption) => {
                                                                handleInputChange({
                                                                    target: {
                                                                        name: "freebieProduct",
                                                                        value: selectedOption ? selectedOption.value : ""
                                                                    }
                                                                });
                                                            }}
                                                            isClearable
                                                            placeholder="Select Freebie Product"
                                                            classNamePrefix="react-select"
                                                            styles={{
                                                                control: (provided, state) => ({
                                                                    ...provided,
                                                                    borderColor: state.isFocused ? "#80bdff" : "#ced4da",
                                                                    boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : null,
                                                                    "&:hover": {
                                                                        borderColor: state.isFocused ? "#80bdff" : "#ced4da",
                                                                    },
                                                                }),
                                                            }}
                                                        />
                                                    </Form.Group>
                                                </Col>

                                                <Col md={2}>
                                                    <Form.Group>
                                                        <Form.Label className="fw-semibold">
                                                            Freebie Quantity <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            name="freebieQuantity"
                                                            value={couponData.freebieQuantity || ``}
                                                            onChange={handleInputChange}
                                                            placeholder="Freebie Quantity"
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </>
                                        )}

                                        {(selectedCheckbox === null || selectedCheckbox === "isSpecialCategoryCoupon" || selectedCheckbox === "isCategoryCoupon" || selectedCheckbox === 'isBogoCoupon' || selectedCheckbox === 'isSizeUpgradeCoupon') && (
                                            <Col md={6} className='mb-3'>
                                                <Form.Label className="fw-semibold">
                                                    Select Applicable Categories
                                                </Form.Label>
                                                <Select
                                                    isMulti
                                                    components={animatedComponents}
                                                    options={categoriesList}
                                                    value={selectedCategories || []}
                                                    onChange={handleSelectCategoryChange}
                                                    placeholder="Select Applicable Categories"
                                                    closeMenuOnSelect={false}
                                                    styles={customStyles}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        borderRadius: 0,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: "#e9ecef",
                                                            primary: "#007bff",
                                                        },
                                                    })}
                                                />
                                            </Col>
                                        )}

                                        {(selectedCheckbox === null || selectedCheckbox === "isSizeUpgradeCoupon") && (
                                            <Col md="6">
                                                <Form.Label className="fw-semibold">
                                                    Select New Size Upgrade Addon <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Select
                                                    name="newSizeUpgradeAddon"
                                                    disabled={selectedCheckbox === "isUniversalCoupon" || selectedCheckbox === "isBogoCoupon" || selectedCheckbox === "isCartCoupon" || selectedCheckbox === "isProductCoupon" || selectedCheckbox === "isCategoryCoupon" || selectedCheckbox === "isSpecialCategoryCoupon" || selectedCheckbox === "isSpecialProductCoupon" || selectedCheckbox === "isComboCoupon" || selectedCheckbox === "isFreebieCoupon" || couponData.sizeUpgradeAddon}
                                                    value={couponData.newSizeUpgradeAddon}
                                                    onChange={(e) => setCouponData((prev) => ({
                                                        ...prev,
                                                        newSizeUpgradeAddon: e.target.value,
                                                    }))}
                                                >
                                                    <option value="">Select Size Upgrade Addon</option>
                                                    {newSizeAddonsList?.map((addon) => (
                                                        <option key={addon._id} value={addon._id}>{addon.title} [{addon.identifier}]</option>
                                                    ))}
                                                </Form.Select>
                                            </Col>
                                        )}

                                        {(selectedCheckbox === null || selectedCheckbox === 'isSpecialProductCoupon' || selectedCheckbox === "isProductCoupon" || selectedCheckbox === 'isSizeUpgradeCoupon') && (
                                            <Col md={6}>
                                                <Form.Label className="fw-semibold">
                                                    Select Applicable Products
                                                </Form.Label>
                                                <Select
                                                    isMulti
                                                    isDisabled={selectedCheckbox === "isBogoCoupon" || selectedCheckbox === "isSpecialCategoryCoupon" || selectedCheckbox === "isCategoryCoupon" || selectedCheckbox === "isUniversalCoupon" || selectedCheckbox === "isCartCoupon" || selectedCheckbox === "isCategoryCoupon" || selectedCheckbox === "isComboCoupon" || selectedCheckbox === "isFreebieCoupon"}
                                                    components={animatedComponents}
                                                    options={couponData.newSizeUpgradeAddon ? addonsProducts : productsInfo}
                                                    value={selectedProducts || []}
                                                    onChange={handleSelectProductChange}
                                                    placeholder="Select Applicable Products"
                                                    styles={customStyles}
                                                    closeMenuOnSelect={false}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        borderRadius: 0,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: "#e9ecef",
                                                            primary: "#007bff",
                                                        },
                                                    })}
                                                />
                                            </Col>
                                        )}

                                        {(selectedCheckbox === null || selectedCheckbox === "isSpecialCategoryCoupon" || selectedCheckbox === "isCategoryCoupon" || selectedCheckbox === 'isSpecialProductCoupon' || selectedCheckbox === "isProductCoupon") && (
                                            <Col md="6" className='mb-3'>
                                                <Form.Label className="fw-semibold ">
                                                    Select Dependent Categories
                                                </Form.Label>
                                                <Select
                                                    isMulti
                                                    components={animatedComponents}
                                                    value={selectedDependentCategories}
                                                    onChange={handleSelectDeCategoriesChange}
                                                    isDisabled={selectedCheckbox === "isBogoCoupon" || selectedCheckbox === "isSizeUpgradeCoupon" || selectedCheckbox === "isCartCoupon" || selectedCheckbox === "isUniversalCoupon" || selectedCheckbox === "isComboCoupon" || selectedCheckbox === "isFreebieCoupon"}
                                                    options={categoriesList}
                                                    styles={customStyles}
                                                    placeholder="Select Dependent Categories"
                                                    closeMenuOnSelect={false}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        borderRadius: 0,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: "#e9ecef",
                                                            primary: "#007bff",
                                                        },
                                                    })}
                                                />
                                            </Col>
                                        )}

                                        {(selectedCheckbox === null || selectedCheckbox === "isSpecialCategoryCoupon" || selectedCheckbox === "isCategoryCoupon" || selectedCheckbox === 'isSpecialProductCoupon' || selectedCheckbox === "isProductCoupon") && (
                                            <Col md="6" className='mb-3'>
                                                <Form.Label className="fw-semibold">
                                                    Select Dependent Products
                                                </Form.Label>
                                                <Select
                                                    isMulti
                                                    components={animatedComponents}
                                                    value={selectedDependentProducts}
                                                    onChange={handleSelectDeProductsChange}
                                                    isDisabled={selectedCheckbox === "isBogoCoupon" || selectedCheckbox === "isSizeUpgradeCoupon" || selectedCheckbox === "isCartCoupon" || selectedCheckbox === "isUniversalCoupon" || selectedCheckbox === "isFreebieCoupon"}
                                                    options={productsInfo}
                                                    styles={customStyles}
                                                    placeholder="Select Dependent Products"
                                                    closeMenuOnSelect={false}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        borderRadius: 0,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: "#e9ecef",
                                                            primary: "#007bff",
                                                        },
                                                    })}
                                                />
                                            </Col>
                                        )}

                                        {(selectedCheckbox === 'isFreebieCoupon' || selectedCheckbox === null || selectedCheckbox === "isSpecialCategoryCoupon" || selectedCheckbox === "isCategoryCoupon" || selectedCheckbox === "isCartCoupon" || selectedCheckbox === 'isSpecialProductCoupon' || selectedCheckbox === "isProductCoupon" || selectedCheckbox === "isSizeUpgradeCoupon" || selectedCheckbox === "isUniversalCoupon" || selectedCheckbox === "isBogoCoupon" || selectedCheckbox === "isComboCoupon") && (
                                            <Col md="6" lg="6" className='mb-3'>
                                                <Form.Label className="fw-semibold">
                                                    Select Excluded Products
                                                </Form.Label>
                                                <Select
                                                    isMulti
                                                    isDisabled={selectedCheckbox === "isProductCoupon" || selectedCheckbox === "isSpecialProductCoupon"}
                                                    components={animatedComponents}
                                                    value={selectedExcludedProducts}
                                                    onChange={handleSelectExProductsChange}
                                                    options={couponData?.newSizeUpgradeAddon ? exAddonsProducts : exProductsInfo}
                                                    styles={customStyles}
                                                    placeholder="Select Excluded Products"
                                                    closeMenuOnSelect={false}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        borderRadius: 0,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: "#e9ecef",
                                                            primary: "#007bff",
                                                        },
                                                    })}
                                                />
                                            </Col>
                                        )}

                                        {(selectedCheckbox !== "isFreebieCoupon") && (
                                            <Col md={6} className='mb-3'>
                                                <Form.Label className="fw-semibold">
                                                    Select Excluding Addons
                                                </Form.Label>
                                                <Select
                                                    components={animatedComponents}
                                                    isMulti
                                                    options={allAddonList?.map(addon => ({
                                                        value: addon._id,
                                                        label: addon.title
                                                    }))}
                                                    value={selectedAddonGroups}
                                                    onChange={(options) => handleSelectAllAddonChange('excludedAddonGroups', options)}
                                                    className="basic-multi-select"
                                                    classNamePrefix="select"
                                                    placeholder="Select addon groups..."
                                                />
                                            </Col>
                                        )}

                                        {(selectedCheckbox !== "isFreebieCoupon") && (
                                            <Col md={6} className='mb-3'>
                                                <Form.Group>
                                                    <Form.Label className='fw-semibold'>Select Excluding Addon Values</Form.Label>
                                                    <Select
                                                        components={animatedComponents}
                                                        isMulti
                                                        options={filteredAddonValues}
                                                        value={couponData?.excludedAddonValues?.map(val => ({
                                                            value: val,
                                                            label: `${allAddonList.find(a => a._id === val.addonId)?.title || ''} - ${allAddonList
                                                                .find(a => a._id === val.addonId)
                                                                ?.addonValues.find(v => v._id === val.addValueId)?.value || ''
                                                                }`
                                                        }))}
                                                        onChange={(selectedOptions) => {
                                                            // Directly update the formData with the selected values
                                                            setCouponData(prev => ({
                                                                ...prev,
                                                                excludedAddonValues: selectedOptions ? selectedOptions.map(opt => opt.value) : []
                                                            }));
                                                        }}
                                                        className="basic-multi-select"
                                                        classNamePrefix="select"
                                                        placeholder="Select addon values to exclude..."
                                                        getOptionLabel={(option) => option.label}
                                                        getOptionValue={(option) => `${option.value.addonId}-${option.value.addValueId}`}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        )}

                                        <Col md="6" lg="6" className="mb-3">
                                            <Form.Label className="fw-semibold">
                                                Select Applicable Levels
                                            </Form.Label>
                                            <Select
                                                isMulti
                                                components={animatedComponents}
                                                value={selectedLevelOptions}
                                                onChange={handleSelectLevelChange}
                                                options={levelsData}
                                                styles={customStyles}
                                                placeholder="Select Applicable Levels"
                                                closeMenuOnSelect={false}
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 0,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: "#e9ecef",
                                                        primary: "#007bff",
                                                    },
                                                })}
                                            />
                                        </Col>

                                        {(selectedCheckbox === null || selectedCheckbox === 'isComboCoupon') && (
                                            <>
                                                <Col md="6" className='mb-3'>
                                                    <Form.Label className="fw-semibold">
                                                        Primary Combo Categories
                                                    </Form.Label>
                                                    <Select
                                                        isMulti
                                                        components={animatedComponents}
                                                        value={primaryComboCategories}
                                                        onChange={handleSelectPrimaryComboCategories}
                                                        options={categoriesList.filter(
                                                            (category) =>
                                                                !secondaryComboCategories?.some(
                                                                    (cat) => cat.value === category.value
                                                                )
                                                        )}
                                                        styles={customStyles}
                                                        placeholder="Primary Combo Categories"
                                                        closeMenuOnSelect={false}
                                                        theme={(theme) => ({
                                                            ...theme,
                                                            borderRadius: 0,
                                                            colors: {
                                                                ...theme.colors,
                                                                primary25: "#e9ecef",
                                                                primary: "#007bff",
                                                            },
                                                        })}
                                                    />
                                                </Col>

                                                <Col md="6" className='mb-3'>
                                                    <Form.Label className="fw-semibold">
                                                        Secondary Combo Categories
                                                    </Form.Label>
                                                    <Select
                                                        isMulti
                                                        components={animatedComponents}
                                                        value={secondaryComboCategories}
                                                        onChange={handleSelectSecondaryComboCategories}
                                                        options={categoriesList.filter(
                                                            (category) =>
                                                                !primaryComboCategories?.some(
                                                                    (cat) => cat.value === category.value
                                                                )
                                                        )}
                                                        styles={customStyles}
                                                        placeholder="Secondary Combo Categories"
                                                        closeMenuOnSelect={false}
                                                        theme={(theme) => ({
                                                            ...theme,
                                                            borderRadius: 0,
                                                            colors: {
                                                                ...theme.colors,
                                                                primary25: "#e9ecef",
                                                                primary: "#007bff",
                                                            },
                                                        })}
                                                    />
                                                </Col>
                                            </>
                                        )}

                                        <Col md="3">
                                            <Form.Label className="fw-semibold">
                                                Hide Coupon <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Select
                                                name="isHidden"
                                                value={couponData.isHidden}
                                                onChange={handleInputChange}
                                            >
                                                <option value="">Select Option</option>
                                                <option value="true">YES</option>
                                                <option value="false">NO</option>
                                            </Form.Select>
                                        </Col>

                                        {(selectedCheckbox !== "isFreebieCoupon") && (
                                            <Col md={3}>
                                                <Form.Label className="fw-semibold">
                                                    Max Addons Allowed
                                                </Form.Label>
                                                <Form.Control
                                                    min={0}
                                                    placeholder="Max Addons Allowed"
                                                    className="no-arrows"
                                                    type="number"
                                                    name="maxAddonsAllowed"
                                                    value={couponData.maxAddonsAllowed || null}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (/^\d*$/.test(value)) {
                                                            handleInputChange(e);
                                                        }
                                                    }}
                                                />
                                            </Col>
                                        )}

                                        {(selectedCheckbox === null || selectedCheckbox === 'isUniversalCoupon' || selectedCheckbox === 'isCartCoupon' || selectedCheckbox === 'isProductCoupon' || selectedCheckbox === 'isCategoryCoupon' || selectedCheckbox === 'isComboCoupon') && (
                                            <>
                                                <Col md={3} className='mb-3'>
                                                    <Form.Label className="fw-semibold">
                                                        Discount Percent <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        min={0}
                                                        max={100}
                                                        disabled={selectedCheckbox === "isBogoCoupon" || selectedCheckbox === "isSizeUpgradeCoupon" || selectedCheckbox === "isSpecialCategoryCoupon" || selectedCheckbox === "isSpecialProductCoupon" || selectedCheckbox === "isFreebieCoupon" || couponData.discountAmount !== "" || couponData.discountAmount || couponData.discountPrice}
                                                        placeholder="Discount Percent"
                                                        className="no-arrows"
                                                        type="number"
                                                        name="discountPercent"
                                                        value={couponData.discountPercent || ""}
                                                        onChange={handleInputChange}
                                                    />
                                                </Col>
                                                <Col md={3}>
                                                    <Form.Label className="fw-semibold">
                                                        Max. Dis. Amount
                                                    </Form.Label>
                                                    <Form.Control
                                                        min={0}
                                                        disabled={selectedCheckbox === "isBogoCoupon" || selectedCheckbox === "isSizeUpgradeCoupon" || selectedCheckbox === "isSpecialCategoryCoupon" || selectedCheckbox === "isSpecialProductCoupon" || selectedCheckbox === "isFreebieCoupon" || couponData.discountAmount !== "" || couponData.discountPrice}
                                                        placeholder="Max. Dis. Amount"
                                                        type="number"
                                                        className="no-arrows"
                                                        name="maxDiscountAmount"
                                                        value={couponData.maxDiscountAmount}
                                                        onChange={handleInputChange}
                                                    />
                                                </Col>
                                            </>
                                        )}

                                        {(selectedCheckbox === null || selectedCheckbox === 'isCartCoupon' || selectedCheckbox === 'isProductCoupon' || selectedCheckbox === 'isCategoryCoupon' || selectedCheckbox === 'isComboCoupon') && (
                                            <Col md={3}>
                                                <Form.Label className="fw-semibold">
                                                    Discount Amount <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    min={0}
                                                    step={0.01}
                                                    disabled={selectedCheckbox === "isBogoCoupon" || selectedCheckbox === "isUniversalCoupon" || selectedCheckbox === "isSizeUpgradeCoupon" || selectedCheckbox === "isSpecialCategoryCoupon" || selectedCheckbox === "isSpecialProductCoupon" || selectedCheckbox === "isFreebieCoupon" || couponData.discountPercent !== "" || couponData.discountPrice}
                                                    placeholder="Discount Amount"
                                                    className="no-arrows"
                                                    type="number"
                                                    name="discountAmount"
                                                    value={couponData.discountAmount || ""}
                                                    onChange={handleInputChange}
                                                />
                                            </Col>
                                        )}

                                        <Col md={3} lg={3} className="mb-3">
                                            <Form.Label className="fw-semibold">
                                                Min. Order Amount {selectedCheckbox === 'isCartCoupon' || selectedCheckbox === 'isFreebieCoupon' ? <span className="text-danger">*</span> : null}
                                            </Form.Label>
                                            <Form.Control
                                                min={0}
                                                placeholder="Min. Order Amount"
                                                type="number"
                                                className="no-arrows"
                                                name="minOrderAmount"
                                                value={couponData.minOrderAmount}
                                                onChange={handleInputChange}
                                            />
                                        </Col>

                                        {(selectedCheckbox !== "isFreebieCoupon") && (
                                            <Col md="3">
                                                <Form.Label className="fw-semibold">
                                                    Is Mrp Coupon? <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Select
                                                    name="isMrpDiscount"
                                                    value={couponData.isMrpDiscount}
                                                    onChange={handleInputChange}
                                                    disabled={selectedCheckbox === "isBogoCoupon" || selectedCheckbox === "isSpecialProductCoupon" || selectedCheckbox === "isCartCoupon" || selectedCheckbox === "isSpecialCategoryCoupon" || selectedCheckbox === "isSizeUpgradeCoupon" || selectedCheckbox === "isFreebieCoupon" || !couponData.discountAmount === "" || selectedCheckbox === "isComboCoupon"}
                                                >
                                                    <option value="">Select Option</option>
                                                    <option value="true">YES</option>
                                                    <option value="false">NO</option>
                                                </Form.Select>
                                            </Col>
                                        )}

                                        {(selectedCheckbox !== "isFreebieCoupon") && (
                                            <Col md="3">
                                                <Form.Label className="fw-semibold">
                                                    Cashback Coupon <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Select
                                                    name="isCashbackCoupon"
                                                    value={couponData.isCashbackCoupon}
                                                    onChange={handleInputChange}
                                                    disabled={selectedCheckbox === "isBogoCoupon" || selectedCheckbox === "isSizeUpgradeCoupon" || selectedCheckbox === "isComboCoupon" || selectedCheckbox === "isFreebieCoupon"}
                                                >
                                                    <option value="">Select Option</option>
                                                    <option value="true">YES</option>
                                                    <option value="false">NO</option>
                                                </Form.Select>
                                            </Col>
                                        )}

                                        {(selectedCheckbox === null || selectedCheckbox === 'isSpecialCategoryCoupon' || selectedCheckbox === 'isSpecialProductCoupon' || selectedCheckbox === 'isComboCoupon') && (
                                            <>
                                                <Col md={3} className='mb-3'>
                                                    <Form.Label className="fw-semibold">
                                                        Discount Price
                                                    </Form.Label>
                                                    <Form.Control
                                                        min={0}
                                                        step={0.01}
                                                        disabled={selectedCheckbox === "isBogoCoupon" || selectedCheckbox === "isUniversalCoupon" || selectedCheckbox === "isProductCoupon" || selectedCheckbox === "isCartCoupon" || selectedCheckbox === "isCategoryCoupon" || selectedCheckbox === "isSizeUpgradeCoupon" || selectedCheckbox === "isFreebieCoupon" || couponData.discountAmount || couponData.discountPercent}
                                                        placeholder="Discount Price"
                                                        className="no-arrows"
                                                        type="number"
                                                        name="discountPrice"
                                                        value={couponData.discountPrice || ""}
                                                        onChange={handleInputChange}
                                                    />
                                                </Col>

                                                <Col md={3} className='mb-3'>
                                                    <div>
                                                        <Form.Label className="fw-semibold">
                                                            Applicable Quantity Type
                                                        </Form.Label>
                                                        <Form.Select
                                                            name="applicableQuantityType"
                                                            value={couponData.applicableQuantityType || ""}
                                                            onChange={handleInputChange}
                                                            disabled={selectedCheckbox === "isBogoCoupon" || selectedCheckbox === "isUniversalCoupon" || selectedCheckbox === "isCartCoupon" || selectedCheckbox === "isProductCoupon" || selectedCheckbox === "isCategoryCoupon" || selectedCheckbox === "isSizeUpgradeCoupon" || selectedCheckbox === "isFreebieCoupon" || couponData.discountAmount || couponData.discountPercent}
                                                        >
                                                            <option value="">Select Applicable Quantity Type</option>
                                                            <option value="SINGLE">SINGLE</option>
                                                            {selectedCheckbox !== 'isComboCoupon' ? <option value="MULTIPLE">MULTIPLE</option> : null}
                                                        </Form.Select>
                                                    </div>
                                                </Col>
                                            </>
                                        )}

                                        <Col md={12} className="mb-3 mt-2">
                                            <Form.Label className="fw-semibold">
                                                Description <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                rows={2}
                                                placeholder="Description"
                                                name="description"
                                                value={couponData.description || ""}
                                                onChange={handleInputChange}
                                            />
                                        </Col>

                                        <Col md="12" className="mb-3">
                                            <div>
                                                <Form.Label className="fw-semibold">
                                                    Terms and Conditions <span className="text-danger">*</span>
                                                </Form.Label>
                                                <div className="d-flex mb-2">
                                                    <Form.Control
                                                        placeholder="Add a term"
                                                        value={currentTerm}
                                                        onChange={(e) => setCurrentTerm(e.target.value)}
                                                        className="me-2"
                                                    />
                                                    <Button
                                                        className="btn-success"
                                                        disabled={!currentTerm.trim()}
                                                        onClick={addTerm}
                                                    >
                                                        ADD
                                                    </Button>
                                                </div>
                                                {couponData?.termsAndConditions?.length > 0 && (
                                                    <ListGroup>
                                                        {couponData?.termsAndConditions?.map((term, index) => (
                                                            <ListGroup.Item
                                                                key={index}
                                                                className="d-flex justify-content-between align-items-center"
                                                            >
                                                                {term}
                                                                <Button
                                                                    variant="danger"
                                                                    size="sm"
                                                                    className="rounded-pill"
                                                                    onClick={() => removeTerm(index)}
                                                                >
                                                                    Remove
                                                                </Button>
                                                            </ListGroup.Item>
                                                        ))}
                                                    </ListGroup>
                                                )}
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Body>
                                <hr className='mt-0' />
                                <Card.Footer className='bg-white mb-3'>
                                    <Button variant="primary" type='submit' style={{ width: '20%' }} disabled={addBtnLoading}>
                                        {addBtnLoading ? <Spinner size='sm' /> : 'ADD COUPON'}
                                    </Button>
                                </Card.Footer>
                            </Form>
                        </Col>
                    </Row>
                </div>
            </div>
        </React.Fragment>
    )
}

export default CreateCoupon